import React from 'react';
import { Text } from '../../../../../../../ui-kit';
import '../styles/_payment-options-title.scss';





function PaymentOptionsTitle({ videoName }) {
  return (
    <div className="payment-options-title">
      <Text
        className="payment-options-title__video-name"
        noMargin
        heading5>

        {`Video Project - ${videoName}`}
      </Text>
    </div>);

}

export default PaymentOptionsTitle;